import { render, staticRenderFns } from "./IdeaEdit.vue?vue&type=template&id=cbc134ea"
import script from "./IdeaEdit.vue?vue&type=script&lang=js"
export * from "./IdeaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports